import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import http from 'src/helper/http'
import { getlang, setlang } from 'src/helper/getlang'
import Message from '../../../component/Message'
import langM from './lang'
import { history } from 'src/core/router'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import { jumpToUser, shareToLink } from 'src/helper/webviewFun'
import localstorage from 'src/helper/localstorage'
import ReminderBtn from 'src/component/RuleButton'
import config from 'src/core/config'
@inject('store')
@observer
export default class extends React.Component {
  state = {
    lang: langM.en,
    language: 'en',
    tableIndex: 0,
    takasOrRank: true,
    hostList: [1],
    hostSystemStatus: 999, // 角色工会状态
    computeStatus: false,
    guildName: '',
    hostSystemInfo: {
      hostSystemId: 0,
      hostSystemName: '3123',
      ownerNickname: '测试6878',
      ownerDuid: '106879',
      ownerAvatarurl: 'http://img.chatie.live/app/man.jpg',
      countryName: 'KSA',
      status: 1,
      submitNum: 15,
    },
    rankingList: [],
    dataList: [],
    countryName: '',
    countryId: '',
    whatsApp: '',
    realName: '',
    timeId: null,
    canApply: false,
    myuid: '',
    myInfo: null,
    bank: '',
    payeeName: '',
    account: '',
    hadSaveChanges: false,
  }

  async componentWillMount() {
    let uid = await setUidToken(this.props.location.query)
    // 设置语言 start
    let { language } = this.props.location.query
    if (language == 'tr') {
      setDocumentTitle('Ajans Sistemi')
    } else if (language == 'en') {
      setDocumentTitle('Host System')
    } else if (language == 'ar') {
      setDocumentTitle(' نظام المضيف')
    }
    language = await getlang(language)
    this.setState({
      lang: setlang(language, langM),
      language: language,
      myuid: uid || null,
    })
    console.log(uid, this.state)
    // end
    this.getHostsystem(uid)
  }
  // 查询工会
  getHostsystem = async (uid) => {
    let res = await http.post('/web/hostsystem/info')
    // 判断状态
    if (res.code == 0 && res.res == null) {
      this.setState({ hostSystemStatus: 991 }) // 未申请
      this.getUserCountry(uid)
    } else if (res.code == 0 && res.res != null) {
      this.setState({
        hostSystemInfo: res.res,
        hostSystemStatus: res.res.status,
        myInfo: res.res.myInfo ? res.res.myInfo : null,
      })
      if (res.res.users && res.res.users.length >= res.res.submitNum) {
        this.setState({ canApply: true })
      }
      this.getRankingList()
      this.getDataList()
    }
  }
  // 获取用户国家
  getUserCountry = async (uid) => {
    let res = await http.post('/web/MyAccountInfo', { uid })
    if (res.code == 0)
      return this.setState({ countryId: res.res.countryId, countryName: res.res.countryName })
  }
  // 创建工会
  createHostSystem = async () => {
    let { guildName, realName, whatsApp } = this
    if (guildName == '') return this.refs.msg.show(this.state.lang.enterAgencyName)
    if (realName == '') return this.refs.msg.show(this.state.lang.enterRealName)
    if (whatsApp == '') return this.refs.msg.show(this.state.lang.enterWhatsApp)
    let res = await http.post('/web/hostsystem/create', {
      hostsystemName: guildName,
      realName,
      whatsApp,
    })
    if (res.code == 0) {
      this.refs.msg.show(this.state.lang.successful)
      this.getHostsystem()
    }
  }
  // 更新工会状态
  upDateHostSystem = async () => {
    let {
      hostSystemInfo: { users, hostSystemId, ownerUid, submitNum },
    } = this.state
    if (users && users.length < submitNum) {
      this.refs.msg.show(this.state.lang.submitTip)
      return
    }
    let res = await http.post('/web/hostsystem/submit', { hostSystemId, uid: ownerUid, status: 1 })
    if (res.code == 0) {
      this.refs.msg.show(this.state.lang.successful)
      this.getHostsystem()
      window.document.documentElement.scrollTop = 0
    }
  }
  selectTbaItem = (index) => {
    this.setState({ tableIndex: index })
  }
  selectRankOrTasks = () => {
    let { takasOrRank } = this.state
    this.setState({ takasOrRank: !takasOrRank })
  }
  // 获取rank、
  getRankingList = async () => {
    let res = await http.post('/web/hostsystem/rank')

    if (res.code == 0 && res.res != null) {
      this.setState({ rankingList: res.res })
    }
  }
  // 获取dataList
  getDataList = async () => {
    let res = await http.post('/web/hostsystem/data')
    if (res.code == 0 && res.res != null) {
      this.setState({ dataList: res.res })
    }
  }
  // 跳转到详情
  clickView = (uid) => {
    let { language } = this.state
    let juuid = language == 'tr' ? 977239 : 113742
    jumpToUser(uid)
  }
  managementGo = () => {
    history.push(`app/managementGo?language=${this.state.language}`)
  }
  // 交互 showModle
  showGoldModle = (open, close) => {
    let { countryName, guildName, realName, whatsApp, lang } = this.state
    return (
      <div
        className="create-modle"
        onClick={() => {
          close()
        }}
      >
        <div className="gold-modletitle">{lang.checkInfuyou}</div>
        <div className="gold-modle-body">
          <div className="amount">
            <div className="amout-left">{lang.agencyName}</div>
            <div className="amout-rigit">{guildName}</div>
          </div>
          <div className="amount">
            <div className="amout-left">{lang.realName}</div>
            <div className="amout-rigit">{realName}</div>
          </div>
          <div className="amount">
            <div className="amout-left">{lang.whatsApp}</div>
            <div className="amout-rigit">{whatsApp}</div>
          </div>
          <div className="amount">
            <div className="amout-left">{lang.countryName}</div>
            <div className="amout-rigit">{countryName}</div>
          </div>
        </div>
        <div className="gold-modle-btn">
          <div
            className="modle-cancle"
            onClick={() => {
              close()
            }}
          >
            {lang.cancel}
          </div>
          <div className="modle-confirm" onClick={() => this.createHostSystem()}>
            {lang.yes}
          </div>
        </div>
      </div>
    )
  }
  // 创建公会信息
  setguildInfo = (a, map) => {
    this[map] = a.target.value
    this.setState({
      [map]: a.target.value,
    })
  }

  hanldeAdminTogo = () => {
    let { language, hostSystemInfo } = this.state
    let baseUrl = 'https://h5-activity.yayya.live'
    if (config.host == 'https://api-test.thechatie.com') {
      baseUrl = 'https://web-test.thechatie.com'
    }
    let url = baseUrl + `/#/app/find-hostJoin?no=ewe&myText=${hostSystemInfo.hostSystemDisplayId}`
    shareToLink(url)
  }

  //
  showListAndTitle = (titie, hostList) => {
    return (
      hostList &&
      hostList.length > 0 && (
        <div className="leader-admins">
          <div className="leader-admins-title">{this.state.lang.hosts}</div>
          {hostList.map((item, index) => (
            <div className="addminList" key={index}>
              <div className="application-user-info" onClick={() => this.clickView(item.uid * 1)}>
                <div className="avatar-root">
                  <img className="avatar-img" src={item.avatarurl}></img>
                  {item.gender == 1 && (
                    <img className="img-gender" src="/img/app/tradeUnion/man_icon.png"></img>
                  )}
                  {item.gender == 2 && (
                    <img className="img-gender" src="/img/app/tradeUnion/women_icon.png"></img>
                  )}
                </div>
                <div className="user-info">
                  <div className="user-info-top">
                    <div className="top-text">{item.nickname}</div>
                    <div className="host-bg">{this.state.lang.host}</div>
                  </div>
                  <div className="user-info-buttom">ID:{item.duid}</div>
                </div>
                {/* <div className="host-get-ruby" onClick={()=>this.hanldeTogo(item)}>
            <div className="ruby-num">{item.target}</div>
            <img className="ruby-forWard" src="/img/app/tradeUnion/icon_chevron_forward.png" ></img>
          </div> */}
              </div>
            </div>
          ))}
        </div>
      )
    )
  }
  // 退出公会
  quitHost = async () => {
    let {
      hostSystemInfo: { roleLevel, hostSystemId },
      myuid,
      language,
      lang,
    } = this.state
    if (roleLevel == 1) return
    console.log(myuid)
    if (myuid == null) {
      return this.refs.msg.show('err')
    }
    let res = await http.post('/web/hostsystem/user/remove', { hostSystemId, uid: myuid })
    if (res.code == 0) {
      this.refs.msg.show(lang.successful)
      history.replace(`app/ruby-join?language=${language}`)
    }
  }

  applyReview = () => {
    /*  if (this.state.hostSystemInfo.roleLevel != 1) return */
    localstorage.set('updataInfo', {
      hostSystemId: this.state.hostSystemInfo.hostSystemId,
      uid: this.state.hostSystemInfo.ownerUid,
      roleLevel: 4,
    })
    history.push(`app/join-application?language=${this.state.language}`)
  }

  stopHandle = (e) => {
    e.stopPropagation()
  }

  // dsadas
  quitShowModle = (open, close) => {
    let { lang } = this.state
    return (
      <div
        className="quit-modle"
        onClick={() => {
          close()
        }}
      >
        <div className="gold-modletitle">{lang.quitText}</div>
        <div className="gold-modle-body"></div>
        <div className="gold-modle-btn">
          <div
            className="modle-cancle"
            onClick={() => {
              close()
            }}
          >
            {lang.cancel}
          </div>
          <div className="modle-confirm" onClick={() => this.quitHost()}>
            {lang.yes}
          </div>
        </div>
      </div>
    )
  }
  //
  handleSetHostUserInfo = (e, keyName) => {
    console.log(e.target.value, keyName)
    this.setState({
      [keyName]: e.target.value,
      hadSaveChanges: true,
    })
    console.log(this.state)
  }
  //
  upHost = async () => {
    let { hadSaveChanges, hostSystemInfo, myuid, bank, account, payeeName, myInfo } = this.state
    if (!hadSaveChanges) return
    let prams = {
      hostSystemId: hostSystemInfo.hostSystemId,
      bank: bank || myInfo.bank,
      account: account || myInfo.account,
      payeeName: payeeName || myInfo.payeeName,
      uid: myuid || 101844,
    }
    let res = await http.post('/web/hostsystem/user/update', prams)
    if (res.code == 0) {
      this.refs.msg.show(this.state.lang.successful)
      this.getHostsystem(myuid)
    }
  }

  async handleGetShareLink(e, idtext) {
    e.stopPropagation()
    shareToLink(idtext)
  }
  render() {
    let {
      lang,
      tableIndex,
      takasOrRank,
      hostList,
      hostSystemStatus,
      computeStatus,
      hostSystemInfo,
      rankingList,
      dataList,
      countryId,
      countryName,
      canApply,
      language,
      myInfo,
      hadSaveChanges,
    } = this.state
    return (
      <div className={`trade-union ${language == 'ar' ? 'in-tr' : ''} `}>
        {hostSystemStatus == 991 && (
          <div className="new-create-guild">
            <div style={{ height: '0.48rem', backgroundColor: '#f5f5fa' }}></div>
            <div className="process-what">
              <div className="process-what-num">1/3</div>
              <div className="process-text">{lang.findinthe}</div>
            </div>
            <div className="create-guild-approval">
              <div className="approval-info">
                <div className="info-title">{lang.cteratInfoTitle}</div>
                <div className="info-title-after"></div>
                <div className="info-text-item">
                  <div className="item-text">{lang.agencyName}</div>
                  <input
                    className="item-info"
                    onChange={(e) => this.setguildInfo(e, 'guildName')}
                    placeholder={lang.enterAgencyName}
                  ></input>
                </div>
                <div className="info-text-item">
                  <div className="item-text">{lang.realName}</div>
                  <input
                    className="item-info"
                    onChange={(e) => this.setguildInfo(e, 'realName')}
                    placeholder={lang.enterRealName}
                  ></input>
                </div>
                <div className="info-text-item">
                  <div className="item-text">{lang.whatsApp}</div>
                  <input
                    className="item-info"
                    onChange={(e) => this.setguildInfo(e, 'whatsApp')}
                    placeholder={lang.enterWhatsApp}
                  ></input>
                </div>
                <div className="info-text-item">
                  <div className="item-text">{lang.countryName}</div>
                  <div className="item-info" style={{ color: 'rgba(54,55,61,0.3)' }}>
                    {countryName}
                  </div>
                </div>
              </div>
            </div>

            <div className="text-tip">{lang.whyNeedName}</div>
            <ReminderBtn
              lang={this.state.lang}
              slotButtonComp={() => {
                return <div className="new-create-btn">{lang.next}</div>
              }}
              slotContentComp={this.showGoldModle}
            />
          </div>
        )}

        {hostSystemStatus == 0 && (
          <div className="new-create-guild">
            <div style={{ height: '0.48rem', backgroundColor: '#f5f5fa' }}></div>
            {hostSystemInfo.roleLevel == 1 && (
              <div className="process-what">
                <div className="process-what-num">2/3</div>
                <div className="process-text">{`${lang.ininyouhost} (${hostSystemInfo.users.length}/${hostSystemInfo.submitNum})`}</div>
              </div>
            )}
            {hostSystemInfo.roleLevel != 1 && (
              <div className="twotext-tip">{lang.intheHostText}</div>
            )}
            <div className="create-guild-approval">
              <div className="approval-info">
                <div className="info-title">{lang.cteratInfoTitle}</div>
                <div className="info-title-after"></div>
                {hostSystemInfo.hostSystemDisplayId && (
                  <div className="info-text-item">
                    <div className="item-text">{lang.guildId}</div>
                    <div className="item-info">{hostSystemInfo.hostSystemDisplayId}</div>
                  </div>
                )}
                <div className="info-text-item">
                  <div className="item-text">{lang.agencyName}</div>
                  <div className="item-info">{hostSystemInfo.hostSystemName}</div>
                </div>
                <div className="info-text-item">
                  <div className="item-text">{lang.realName}</div>
                  <div className="item-info">{hostSystemInfo.ownerRealName}</div>
                </div>
                <div className="info-text-item">
                  <div className="item-text">{lang.whatsApp}</div>
                  {hostSystemInfo.roleLevel == 1 && (
                    <div className="item-info">{hostSystemInfo.ownerWhatsApp}</div>
                  )}
                  {hostSystemInfo.roleLevel != 1 && (
                    <div className="item-info">{`*******${hostSystemInfo.ownerWhatsApp.slice(
                      hostSystemInfo.ownerWhatsApp.length - 3,
                      hostSystemInfo.ownerWhatsApp.length,
                    )}`}</div>
                  )}
                </div>
                <div className="info-text-item">
                  <div className="item-text">{lang.countryName}</div>
                  <div className="item-info" style={{ color: 'rgba(54,55,61,0.3)' }}>
                    {hostSystemInfo.countryName}
                  </div>
                </div>
              </div>
            </div>
            {false && hostSystemInfo.roleLevel == 1 && (
              <div className="add-host" onClick={this.hanldeAdminTogo}>
                <img
                  className="add-host-icon"
                  src="/img/app/managementGo/icon_person_plus.png"
                ></img>
                <div className="add-host-title">{lang.shareText}</div>
              </div>
            )}

            {language == 'ar' && (
              <div className="show-sb-want" onClick={this.stopHandle}>
                ارسل الايدي الخاص بك
                <span
                  className="owner-uid"
                  onClick={(e) => this.handleGetShareLink(e, hostSystemInfo.ownerDuid)}
                >
                  {hostSystemInfo.ownerDuid}
                </span>{' '}
                او ايدي الوكاله
                <span
                  className="hostsystem-id"
                  onClick={(e) => this.handleGetShareLink(e, hostSystemInfo.hostSystemDisplayId)}
                >
                  {hostSystemInfo.hostSystemDisplayId}
                </span>
                ، لكي يتم العثور على الوكاله وطلب الإنضمام
              </div>
            )}
            {language == 'en' && (
              <div className="show-sb-want" onClick={this.stopHandle}>
                Please tell other users your user ID{' '}
                <span
                  className="owner-uid"
                  onClick={(e) => this.handleGetShareLink(e, hostSystemInfo.ownerDuid)}
                >
                  {hostSystemInfo.ownerDuid}
                </span>{' '}
                or agency ID{' '}
                <span
                  className="hostsystem-id"
                  onClick={(e) => this.handleGetShareLink(e, hostSystemInfo.hostSystemDisplayId)}
                >
                  {hostSystemInfo.hostSystemDisplayId}
                </span>
                , they will find and join
              </div>
            )}
            {language == 'zh' && (
              <div className="show-sb-want" onClick={this.stopHandle}>
                Please tell other users your user ID{' '}
                <span
                  className="owner-uid"
                  onClick={(e) => this.handleGetShareLink(e, hostSystemInfo.ownerDuid)}
                >
                  {hostSystemInfo.ownerDuid}
                </span>{' '}
                or agency ID{' '}
                <span
                  className="hostsystem-id"
                  onClick={(e) => this.handleGetShareLink(e, hostSystemInfo.hostSystemDisplayId)}
                >
                  {hostSystemInfo.hostSystemDisplayId}
                </span>
                , they will find and join
              </div>
            )}
            {language == 'tr' && (
              <div className="show-sb-want" onClick={this.stopHandle}>
                Lütfen ajansınıza katılmak isteyen kullanıcılara hesap ID’nizi{' '}
                <span
                  className="owner-uid"
                  onClick={(e) => this.handleGetShareLink(e, hostSystemInfo.ownerDuid)}
                >
                  {hostSystemInfo.ownerDuid}
                </span>{' '}
                ve ya ajans ID’nizi{' '}
                <span
                  className="hostsystem-id"
                  onClick={(e) => this.handleGetShareLink(e, hostSystemInfo.hostSystemDisplayId)}
                >
                  {hostSystemInfo.hostSystemDisplayId}
                </span>{' '}
                veriniz. “Ajans Bul” Alanından ID’leri arattırarak başvuru yapabilirler.
              </div>
            )}
            {hostSystemInfo.roleLevel != 1 && (
              <div className="quit-agency" onClick={() => this.quitHost()}>
                {lang.quitagency}
              </div>
            )}

            {hostSystemInfo.roleLevel == 1 && (
              <div className="add-host" onClick={this.applyReview} style={{ marginTop: '0.24rem' }}>
                <img
                  className="add-host-icon"
                  src="/img/app/managementGo/icon_file_check.png"
                ></img>
                <div className="add-host-title">{lang.joinapplication}</div>
                <img
                  className="to-add-host"
                  src="/img/app/tradeUnion/icon_chevron_forward.png"
                  style={{
                    marginRight: `${language == 'ar' ? 'auto' : ''}`,
                    marginLeft: `${language == 'ar' ? '' : 'auto'}`,
                  }}
                ></img>
              </div>
            )}
            <div className="host-list">
              <div className="title">
                <div className="title-left">{lang.hostList}</div>
                {/* <div className='title-right'></div> */}
              </div>
              <div className="info-title-after"></div>
              <div className="leader-admins">
                <div className="leader-admins-title">{lang.leaderAdmins}</div>
                {/* Leader */}
                <div
                  className="application-user-info"
                  onClick={() => this.clickView(hostSystemInfo.ownerUid * 1)}
                >
                  <div className="avatar-root">
                    <img className="avatar-img" src={hostSystemInfo.ownerAvatarurl}></img>
                    {hostSystemInfo.gender == 1 && (
                      <img className="img-gender" src="/img/app/tradeUnion/man_icon.png"></img>
                    )}
                    {hostSystemInfo.gender == 2 && (
                      <img className="img-gender" src="/img/app/tradeUnion/women_icon.png"></img>
                    )}
                  </div>
                  <div className="user-info">
                    <div className="user-info-top">
                      <div className="top-text">{hostSystemInfo.ownerNickname}</div>
                      <div className="vip-bg">Leader</div>
                    </div>
                    <div className="user-info-buttom">ID:{hostSystemInfo.ownerDuid}</div>
                  </div>
                </div>
              </div>
              {true && this.showListAndTitle('Hosts', hostSystemInfo.users)}
            </div>
          </div>
        )}
        {hostSystemStatus == 1 && (
          <div className="new-create-guild">
            <div style={{ height: '0.48rem', backgroundColor: '#f5f5fa' }}></div>
            <div className="new-img-root">
              <img
                className="new-ok-img"
                src="/img/app/tradeUnion/icon_actionstatus_successfull.png"
              ></img>
            </div>
            <div className="succ-text">{lang.submitSuccess}</div>
            <div className="wait-text">
              {lang.willpossible}
              <br />
              {lang.thankyou}
            </div>
            <div className="create-guild-approval">
              <div className="approval-info">
                <div className="info-title">{lang.cteratInfoTitle}</div>
                <div className="info-title-after"></div>
                <div className="info-text-item">
                  <div className="item-text">{lang.agencyName}</div>
                  <div className="item-info">{hostSystemInfo.hostSystemName}</div>
                </div>
                <div className="info-text-item">
                  <div className="item-text">{lang.realName}</div>
                  <div className="item-info">{hostSystemInfo.ownerRealName}</div>
                </div>
                <div className="info-text-item">
                  <div className="item-text">{lang.whatsApp}</div>
                  {hostSystemInfo.roleLevel == 1 && (
                    <div className="item-info">{hostSystemInfo.ownerWhatsApp}</div>
                  )}
                  {hostSystemInfo.roleLevel != 1 && (
                    <div className="item-info">{`********${hostSystemInfo.ownerWhatsApp.slice(
                      hostSystemInfo.ownerWhatsApp.length - 3,
                      hostSystemInfo.ownerWhatsApp.length,
                    )}`}</div>
                  )}
                </div>
                <div className="info-text-item">
                  <div className="item-text">{lang.countryName}</div>
                  <div className="item-info" style={{ color: 'rgba(54,55,61,0.3)' }}>
                    {hostSystemInfo.countryName}
                  </div>
                </div>
              </div>
            </div>
            {false && hostSystemStatus != 1 && (
              <div className="add-host">
                <img
                  className="add-host-icon"
                  src="/img/app/managementGo/icon_person_plus.png"
                ></img>
                <div className="add-host-title">{lang.shareText}</div>
              </div>
            )}
            {hostSystemInfo.roleLevel != 1 && (
              <div className="quit-agency" onClick={() => this.quitHost()}>
                {lang.quitagency}
              </div>
            )}
            <div className="host-list">
              <div className="title">
                <div className="title-left">{lang.hostList}</div>
                {/* <div className='title-right'></div> */}
              </div>
              <div className="info-title-after"></div>
              <div className="leader-admins">
                <div className="leader-admins-title">{lang.leaderAdmins}</div>
                {/* Leader */}
                <div className="application-user-info">
                  <div className="avatar-root">
                    <img className="avatar-img" src={hostSystemInfo.ownerAvatarurl}></img>
                    {hostSystemInfo.gender == 1 && (
                      <img className="img-gender" src="/img/app/tradeUnion/man_icon.png"></img>
                    )}
                    {hostSystemInfo.gender == 2 && (
                      <img className="img-gender" src="/img/app/tradeUnion/women_icon.png"></img>
                    )}
                  </div>
                  <div
                    className="user-info"
                    onClick={() => this.clickView(hostSystemInfo.ownerUid * 1)}
                  >
                    <div className="user-info-top">
                      <div className="top-text">{hostSystemInfo.ownerNickname}</div>
                      <div className="vip-bg">Leader</div>
                    </div>
                    <div className="user-info-buttom">ID:{hostSystemInfo.ownerDuid}</div>
                  </div>
                </div>
              </div>
              {true && this.showListAndTitle('Hosts', hostSystemInfo.users)}
            </div>
          </div>
        )}
        {/* table */}
        {hostSystemStatus == 3 && (
          <div className="tabele-roosse">
            {this.state.lang &&
              this.state.lang.tableItem &&
              this.state.lang.tableItem.map((item, index) => {
                return (
                  <div className="tabele-root-item-union" key={index}>
                    <div
                      className={`item-txet ${tableIndex == index ? 'atv-item-color' : ''}`}
                      onClick={() => this.selectTbaItem(index)}
                      key={index}
                    >
                      {item}
                    </div>
                    <div className={`select-atv ${tableIndex == index ? 'atv-bg' : ''}`}></div>
                  </div>
                )
              })}
          </div>
        )}
        {/* 审批中 &&已有 */}
        {hostSystemStatus == 3 && tableIndex === 0 && (
          <div>
            <div className="approval">
              {hostSystemStatus != 3 && (
                <div style={{ height: '0.24rem', backgroundColor: '#f5f5fa' }}></div>
              )}
              <div className="approval-info">
                <div className="info-title">
                  {lang.guildInformation} <span className="pass-text">{lang.passText}</span>
                </div>
                <div className="info-title-after"></div>
                <div className="info-text-item">
                  <div className="item-text">{lang.agencyName}</div>
                  <div className="item-info">{hostSystemInfo.hostSystemName}</div>
                </div>
                <div className="info-text-item">
                  <div className="item-text">{lang.guildId}</div>
                  <div className="item-info">{hostSystemInfo.hostSystemDisplayId}</div>
                </div>
                <div className="info-text-item">
                  <div className="item-text">{lang.countryName}</div>
                  <div className="item-info">{hostSystemInfo.countryName}</div>
                </div>
                <div className="info-text-item">
                  <div className="item-text">{lang.hostTitleText}</div>
                  <div className="item-info">{hostSystemInfo.hostNum}</div>
                </div>
                <div className="info-text-item">
                  <div className="item-text">{lang.timeCreated}</div>
                  <div className="item-info">{hostSystemInfo.CreatedTimeStr}</div>
                </div>
              </div>
            </div>

            {false && (
              <div className="add-host" onClick={this.hanldeAdminTogo}>
                <img
                  className="add-host-icon"
                  src="/img/app/managementGo/icon_person_plus.png"
                ></img>
                <div className="add-host-title">{lang.shareText}</div>
              </div>
            )}

            {language == 'ar' && (
              <div className="show-sb-want" onClick={this.stopHandle}>
                ارسل الايدي الخاص بك
                <span
                  className="owner-uid"
                  onClick={(e) => this.handleGetShareLink(e, hostSystemInfo.ownerDuid)}
                >
                  {hostSystemInfo.ownerDuid}
                </span>{' '}
                او ايدي الوكاله
                <span
                  className="hostsystem-id"
                  onClick={(e) => this.handleGetShareLink(e, hostSystemInfo.hostSystemDisplayId)}
                >
                  {hostSystemInfo.hostSystemDisplayId}
                </span>
                ، لكي يتم العثور على الوكاله وطلب الإنضمام
              </div>
            )}
            {language == 'en' && (
              <div className="show-sb-want" onClick={this.stopHandle}>
                Please tell other users your user ID{' '}
                <span
                  className="owner-uid"
                  onClick={(e) => this.handleGetShareLink(e, hostSystemInfo.ownerDuid)}
                >
                  {hostSystemInfo.ownerDuid}
                </span>{' '}
                or agency ID{' '}
                <span
                  className="hostsystem-id"
                  onClick={(e) => this.handleGetShareLink(e, hostSystemInfo.hostSystemDisplayId)}
                >
                  {hostSystemInfo.hostSystemDisplayId}
                </span>
                , they will find and join
              </div>
            )}
            {language == 'zh' && (
              <div className="show-sb-want" onClick={this.stopHandle}>
                Please tell other users your user ID{' '}
                <span
                  className="owner-uid"
                  onClick={(e) => this.handleGetShareLink(e, hostSystemInfo.ownerDuid)}
                >
                  {hostSystemInfo.ownerDuid}
                </span>{' '}
                or agency ID{' '}
                <span
                  className="hostsystem-id"
                  onClick={(e) => this.handleGetShareLink(e, hostSystemInfo.hostSystemDisplayId)}
                >
                  {hostSystemInfo.hostSystemDisplayId}
                </span>
                , they will find and join
              </div>
            )}
            {language == 'tr' && (
              <div className="show-sb-want" onClick={this.stopHandle}>
                Lütfen ajansınıza katılmak isteyen kullanıcılara hesap ID’nizi{' '}
                <span
                  className="owner-uid"
                  onClick={(e) => this.handleGetShareLink(e, hostSystemInfo.ownerDuid)}
                >
                  {hostSystemInfo.ownerDuid}
                </span>{' '}
                ve ya ajans ID’nizi{' '}
                <span
                  className="hostsystem-id"
                  onClick={(e) => this.handleGetShareLink(e, hostSystemInfo.hostSystemDisplayId)}
                >
                  {hostSystemInfo.hostSystemDisplayId}
                </span>{' '}
                veriniz. “Ajans Bul” Alanından ID’leri arattırarak başvuru yapabilirler.
              </div>
            )}
            {/* 工会申请者信息 */}
            {
              <div className="application-user">
                <div className="application-title">{lang.guildLeader}</div>
                <div className="info-title-after"></div>
                <div className="application-user-info">
                  <div className="avatar-root">
                    <img className="avatar-img" src={hostSystemInfo.ownerAvatarurl}></img>
                    {hostSystemInfo.gender == 1 && (
                      <img className="img-gender" src="/img/app/tradeUnion/man_icon.png"></img>
                    )}
                    {hostSystemInfo.gender == 2 && (
                      <img className="img-gender" src="/img/app/tradeUnion/women_icon.png"></img>
                    )}
                  </div>
                  <div className="user-info">
                    <div className="user-info-top">
                      <div className="top-text">{hostSystemInfo.ownerNickname}</div>
                      <div className="vip-bg">{lang.leader}</div>
                    </div>
                    <div className="user-info-buttom">ID:{hostSystemInfo.ownerDuid}</div>
                  </div>
                  <div
                    className="view-btn"
                    onClick={() => this.clickView(hostSystemInfo.ownerUid * 1)}
                    style={{
                      marginRight: `${language == 'ar' ? 'auto' : ''}`,
                      marginLeft: `${language == 'ar' ? '' : 'auto'}`,
                    }}
                    sa={123}
                  >
                    {lang.view}
                  </div>
                </div>
              </div>
            }
            {/* buzhi */}
            {hostSystemInfo.status == 3 && hostSystemInfo.roleLevel != 3 && (
              <div className="guild-management" onClick={this.managementGo}>
                <div className="guild-management-top">{lang.guildManagement}</div>
                <div className="info-title-after"></div>
                <div className="guild-management-buttom">
                  <div style={{ display: 'flex' }}>
                    <img
                      className="icon-styem"
                      src="/img/app/tradeUnion/icon_person_gear.png"
                    ></img>
                    <div className="manage-host">{lang.manageHost}</div>
                  </div>
                  <img
                    className="management-go"
                    src="/img/app/tradeUnion/icon_chevron_forward.png"
                  ></img>
                </div>
              </div>
            )}
            {myInfo && (
              <div className="usermyinfo-user">
                <div className="application-title">{lang.myInfoText}</div>
                <div className="info-title-after"></div>
                <div className="application-user-info">
                  <div className="avatar-root">
                    <img className="avatar-img" src={myInfo.MyAvatarurl}></img>
                    {myInfo.myGender == 1 && (
                      <img className="img-gender" src="/img/app/tradeUnion/man_icon.png"></img>
                    )}
                    {myInfo.myGender == 2 && (
                      <img className="img-gender" src="/img/app/tradeUnion/women_icon.png"></img>
                    )}
                  </div>
                  <div className="user-info">
                    <div className="user-info-top">
                      <div className="top-text">{myInfo.myNickname}</div>
                      {hostSystemInfo.roleLevel == 3 && <div className="host-bg">{lang.host}</div>}
                    </div>
                    <div className="user-info-buttom">ID:{myInfo.myDuid}</div>
                  </div>
                  <div></div>
                </div>
                <div className="info-text-item">
                  <div className="item-text">{lang.onMicTime}</div>
                  <div className="item-info">{`${myInfo.day || 0}  ${lang.days}`}</div>
                </div>
                <div className="info-text-item">
                  <div className="item-text">{lang.bankNameText}</div>
                  <input
                    className="item-info"
                    defaultValue={myInfo.bank}
                    onChange={(e) => this.handleSetHostUserInfo(e, 'bank')}
                    placeholder={lang.bankNameText}
                  ></input>
                </div>
                <div className="info-text-item">
                  <div className="item-text">{lang.bankIdText}</div>
                  <input
                    className="item-info"
                    defaultValue={myInfo.account}
                    onChange={(e) => this.handleSetHostUserInfo(e, 'account')}
                    style={{ flex: 6 }}
                    placeholder={lang.bankIdText}
                  ></input>
                </div>
                <div className="info-text-item">
                  <div className="item-text">{lang.payeeName}</div>
                  <input
                    className="item-info"
                    defaultValue={myInfo.payeeName}
                    onChange={(e) => this.handleSetHostUserInfo(e, 'payeeName')}
                    placeholder={lang.payeeName}
                  ></input>
                </div>
              </div>
            )}
            {
              <div
                className={hadSaveChanges ? 'in-save-changes-host' : 'no-save-changes-host'}
                onClick={() => this.upHost()}
              >
                {lang.saveChanges}
              </div>
            }
            {hostSystemInfo.roleLevel != 1 && (
              <ReminderBtn
                lang={this.state.lang}
                slotButtonComp={() => {
                  return <div className="quit-agency">{lang.quitagency}</div>
                }}
                slotContentComp={this.quitShowModle}
              />
            )}
            {/* 审核中按钮 */}
          </div>
        )}
        {/* host */}
        {hostSystemStatus == 3 && tableIndex === 1 && (
          <div className="host-bug">
            <div className="tasks-rank">
              <div className="rank">{lang.ranking}</div>
            </div>
            <div className="list">
              <div className="list-title">
                <div className="title-text">{lang.hostRanking}</div>
                <div className="title-time"></div>
              </div>
              <div className="info-title-after"></div>
              {tableIndex === 1 &&
                rankingList.map((item, index) => {
                  return (
                    <div className="list-item" key={index}>
                      <div className="serial-number">{index + 1}</div>
                      <div className="host-info">
                        <div className="avatar-root-host">
                          <img className="avatar-img-host" src={item.InviteeAvatarurl}></img>
                          {item.InviteeGender == 1 && (
                            <img
                              className="img-genderss"
                              src="/img/app/tradeUnion/man_icon.png"
                            ></img>
                          )}
                          {item.InviteeGender == 2 && (
                            <img
                              className="img-genderss"
                              src="/img/app/tradeUnion/women_icon.png"
                            ></img>
                          )}
                        </div>
                        <div className="user-info" style={{ display: 'flex' }}>
                          <div className="user-info-top">
                            <div className="top-text">{item.InviteeNickname}</div>
                            {item.roleLevel == 3 && <div className="host-bg">{lang.host}</div>}
                            {item.roleLevel == 1 && <div className="vip-bg">{lang.leader}</div>}
                            {item.roleLevel == 2 && <div className="admin-bg">{lang.admin}</div>}
                          </div>
                        </div>
                      </div>
                      <div className="host-get-ruby">
                        <div className="ruby-num">{item.rankVal}</div>
                      </div>
                    </div>
                  )
                })}
            </div>
          </div>
        )}
        {/* data */}
        {hostSystemStatus == 3 &&
          tableIndex == 2 &&
          dataList.map((item, index) => {
            return (
              <div className="data-root" key={index}>
                <div className="data-root-item">
                  <div className="application-user-info">
                    <div className="avatar-root">
                      <img className="avatar-img" src={item.avatarurl}></img>
                      {item.gender == 1 && (
                        <img className="img-gender" src="/img/app/tradeUnion/man_icon.png"></img>
                      )}
                      {item.gender == 2 && (
                        <img className="img-gender" src="/img/app/tradeUnion/women_icon.png"></img>
                      )}
                    </div>
                    <div className="user-info">
                      <div className="user-info-top">
                        <div className="top-text">{item.nickname}</div>
                        {item.roleLevel == 1 && <div className="vip-bg">{lang.leader}</div>}
                        {item.roleLevel == 3 && <div className="host-bg">{lang.host}</div>}
                        {item.roleLevel == 2 && <div className="admin-bg">{lang.admin}</div>}
                      </div>
                      <div className="user-info-buttom">ID:{item.uid}</div>
                    </div>
                    <div
                      className="view-btn"
                      onClick={() => this.clickView(item.uid)}
                      style={{
                        marginRight: `${language == 'ar' ? 'auto' : ''}`,
                        marginLeft: `${language == 'ar' ? '' : 'auto'}`,
                      }}
                      sa={123}
                    >
                      {lang.view}
                    </div>
                  </div>
                  <div className="live-item">
                    <div className="live-title">{lang.liveDurationthisMonth}</div>
                    <div className="live-time">{`${parseInt(item.durationThisMonth / 60)}${lang.hour} ${
                      item.durationThisMonth % 60
                    }${lang.min} `}</div>
                  </div>
                  <div className="live-item">
                    <div className="live-title">{lang.targetThisMonth}</div>
                    <div className="host-get-ruby">
                      {/* <img className="ruby-icon" src="/img/app/ruby/icon_ruby_get.png"></img> */}
                      <div className="ruby-num">{item.targetThisMonth}</div>
                    </div>
                  </div>
                  {/*                   <div className="live-item">
                    <div className="live-title">{lang.target}</div>
                    <div className="host-get-ruby">
                       <img className="ruby-icon" src="/img/app/ruby/icon_ruby_get.png"></img>
                      <div className="ruby-num">{item.target}</div>
                    </div>
                  </div> */}
                  <div className="buttom-div"></div>
                </div>
              </div>
            )
          })}
        {/* 已有工会 */}
        {hostSystemStatus == 0 && hostSystemInfo.roleLevel == 1 && (
          <div
            className={`sbumin-btn ${canApply ? 'canApply' : ''}`}
            onClick={this.upDateHostSystem}
          >
            {lang.submit}
          </div>
        )}
        {hostSystemStatus == 0 && hostSystemInfo.roleLevel == 1 && (
          <div
            className="threetext-tip"
            onClick={() => {
              let is = language == 'tr' ? 977239 : 113742
              this.clickView(is)
            }}
          >
            {lang.toOneUser}
          </div>
        )}
        <Message ref="msg" />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/tradeUnion/index.js